import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../redux/configureStore';
import Wrapper from '../../../../shared/components/Wrapper';
import CardTotal from './components/CardTotal';
import ClientsTableList from './components/ClientsTableList';
import Frame from './components/Frame';
import Switcher from './components/Switcher';

function ClientsApp() {
  const clientListContext = useSelector(
    (reducer: IReducer) => reducer.clientsApp
  );

  const loading = useMemo(() => {
    if (clientListContext.isLoading === true) {
      return (
        <Wrapper.Default margin="20% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [clientListContext.isLoading]);

  const TableComponent = useMemo(() => {
    if (clientListContext.clientsList.totalBalance === undefined) {
      Swal.fire('Não há clientes');
      return <></>;
    }
    if (clientListContext.isActive === false) {
      return <></>;
    }
    return (
      <>
        <CardTotal />
        <ClientsTableList />
      </>
    );
  }, [clientListContext.clientsList.clients]);

  return (
    <Frame.Base>
      <Switcher />
      {loading}
      {TableComponent}
    </Frame.Base>
  );
}

export default ClientsApp;
